import React from 'react';
import { Check } from 'lucide-react';
import { mockWhyChoose } from '../mock';

const WhyChoose = () => {
  return (
    <section className="section-padding" style={{ 
      background: 'linear-gradient(rgba(255, 254, 249, 0.95), rgba(255, 254, 249, 0.95)), url("https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=2000")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="luxury-container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px' }}>
            Why Choose Enliven Elite Tax Pro
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Experience the difference of working with dedicated tax professionals
          </p>
        </div>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          {mockWhyChoose.map((item, index) => (
            <div
              key={item.id}
              style={{
                display: 'flex',
                gap: '24px',
                padding: '32px 0',
                borderTop: index === 0 ? 'none' : '1px solid var(--border-light)'
              }}
            >
              <div style={{ flexShrink: 0, marginTop: '4px' }}>
                <div
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    background: 'var(--text-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Check size={14} color="var(--bg-primary)" strokeWidth={3} />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                  {item.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;